<template>
  <div class="index-top-navigation" v-if="indexTopNavigationr && indexTopNavigationr.length">
      <div class="nav-item" v-for="item in indexTopNavigationr" :key="item.title">
          <img @click="goPage(item)" :src="item.img" alt="">
          <span>{{item.title}}</span>
      </div>
  </div>
</template>

<script>
import { getCookie } from '@/utils/cookies'
import { toLogin } from '@/utils/common'
export default {
  name: 'm-index-banner',
  props: ['indexTopNavigationr'],
  data () {
    return {
      defaultImg: '../assets/images/icon_user.png',
      bannerList: [
      ]
    }
  },
  mounted(){
  },
  methods: {
    goPage (item) {
      if (item.mustLogin) {
        if (!getCookie('ticket') && $HMD$.rNavigator !== 'msite') {
          toLogin()
          return
        }
        if ($HMD$.rNavigator === 'msite' && (!getCookie('accountId') && !getCookie('AccountId'))) {
          toLogin()
          return
        }
      }
      if (item.url) {
        window.location.href = item.url
      }

      // if(item.title=='个人中心'){

      //   if($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')){
      //     $HMD$.GetLogin(function (data) {
      //       if (data.AccountId) {
      //        //跳转个人中心页面
      //         window.location.href = '/personal/center.html'
      //       } else {
      //         toLogin()
      //       }
      //     })
      //   }

      //   if ($HMD$.rNavigator === 'msite' && (!getCookie('accountId') && !getCookie('AccountId'))) {
      //     toLogin()
      //     return
      //   }else{
      //     //跳转个人中心页面
      //     window.location.href = '/personal/center.html'
      //   }

      // }else if(item.title=='提交设计需求'){
      //   if($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')){
      //     $HMD$.GetLogin(function (data) {
      //       if (data.AccountId) {
      //        //跳转个人中心页面
      //        window.location.href = '/need/add.html'
      //       } else {
      //         toLogin()
      //       }
      //     })
      //   }

      //   if ($HMD$.rNavigator === 'msite' && (!getCookie('accountId') && !getCookie('AccountId'))) {
      //     toLogin()
      //     return
      //   }else{
      //     //跳转个人中心页面
      //     window.location.href = '/need/add.html'
      //   }

      // }else{
      //   if (item.mustLogin) {
      //     // eslint-disable-next-line no-undef
      //     if (!getCookie('ticket') && $HMD$.rNavigator !== 'msite') {
      //       toLogin()
      //       return
      //     }
      //     // eslint-disable-next-line no-undef
      //     if ($HMD$.rNavigator === 'msite' && (!getCookie('accountId') && !getCookie('AccountId'))) {
      //       toLogin()
      //       return
      //     }
      //   }
      //   if (item.url) {
      //     window.location.href = item.url
      //   }
      // }
    }
  }
}
</script>

<style lang="scss">
  .index-top-navigation {
    width: 343px;
    background: #FFF;
    margin: 0 auto;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .nav-item {
        width: 85.4px;
        height: 85px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        img {
            width: 40px;
            height: 40px;
            margin-bottom: 8px;
        }
        span {
            font-size: 11px;
            color: #000;
            line-height: 1;
            white-space:nowrap
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/indexTemplate/topNavigation.vue